//
const sifrantSetSelectValueAndLabel = (
  sifrant,
  valueKey = "id",
  labelKey = "naziv",
) => {
  if (!sifrant) return [];

  const sifrantArrayWithLabelAndValue = sifrant?.map((item) => ({
    value: item[valueKey],
    label: item[labelKey],
  }));
  return sifrantArrayWithLabelAndValue;
};

export default sifrantSetSelectValueAndLabel;
